import fetchClient from './fetchClient';
import { errorHandler } from './utils';

export interface ChatMessage {
    role: 'user' | 'assistant';
    content: string;
}

const config = () => ({
    headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
    },
});

export const sendAIMessage = async (
    messages: ChatMessage[],
): Promise<{ reply: string } | null> => {
    const res: any = await fetchClient
        .post('/ai/chat', { messages }, config())
        .catch(errorHandler);
    if (!res || res.error) return null;
    return res.data;
};
